import React from "react";
import { skills } from "../data";
import "./PageStyles.css";

const getLevelColor = (level) => {
  switch (level) {
    case "Expert":
      return "var(--brand-primary)";
    case "Advanced":
      return "#4ade80";
    case "Intermediate":
      return "#60a5fa";
    default:
      return "var(--text-secondary)";
  }
};

const SkillsPage = () => (
  <div className="page">
    <header className="page-header">
      <h1 className="section-title">Technical Skills</h1>
      <p className="page-lead">The tools, stacks, and platforms I use to build exceptional digital experiences.</p>
    </header>
    <section className="section section-dark">
      <div className="container">
        <div className="skills-grid-enhanced">
          <div className="skill-category-card">
            <div className="skill-category-header">
              <h3 className="skill-category-title">Frontend Development</h3>
              <p className="skill-category-desc">Building responsive and interactive user interfaces</p>
            </div>
            <div className="skill-items">
              {skills.frontend.map((skill, index) => (
                <div key={index} className="skill-item">
                  <div className="skill-item-header">
                    <span className="skill-name">{skill.name}</span>
                    <span 
                      className="skill-level" 
                      style={{ color: getLevelColor(skill.level) }}
                    >
                      {skill.level}
                    </span>
                  </div>
                  <div className="skill-progress-bar">
                    <div 
                      className="skill-progress-fill"
                      style={{ 
                        width: skill.level === "Expert" ? "100%" : skill.level === "Advanced" ? "85%" : "70%",
                        backgroundColor: getLevelColor(skill.level)
                      }}
                    ></div>
                  </div>
                </div>
              ))}
            </div>
          </div>

          <div className="skill-category-card">
            <div className="skill-category-header">
              <h3 className="skill-category-title">Backend Development</h3>
              <p className="skill-category-desc">Creating robust APIs and server-side solutions</p>
            </div>
            <div className="skill-items">
              {skills.backend.map((skill, index) => (
                <div key={index} className="skill-item">
                  <div className="skill-item-header">
                    <span className="skill-name">{skill.name}</span>
                    <span 
                      className="skill-level" 
                      style={{ color: getLevelColor(skill.level) }}
                    >
                      {skill.level}
                    </span>
                  </div>
                  <div className="skill-progress-bar">
                    <div 
                      className="skill-progress-fill"
                      style={{ 
                        width: skill.level === "Expert" ? "100%" : skill.level === "Advanced" ? "85%" : "70%",
                        backgroundColor: getLevelColor(skill.level)
                      }}
                    ></div>
                  </div>
                </div>
              ))}
            </div>
          </div>

          <div className="skill-category-card">
            <div className="skill-category-header">
              <h3 className="skill-category-title">Databases</h3>
              <p className="skill-category-desc">Designing and managing efficient data storage</p>
            </div>
            <div className="skill-items">
              {skills.databases.map((skill, index) => (
                <div key={index} className="skill-item">
                  <div className="skill-item-header">
                    <span className="skill-name">{skill.name}</span>
                    <span 
                      className="skill-level" 
                      style={{ color: getLevelColor(skill.level) }}
                    >
                      {skill.level}
                    </span>
                  </div>
                  <div className="skill-progress-bar">
                    <div 
                      className="skill-progress-fill"
                      style={{ 
                        width: skill.level === "Expert" ? "100%" : skill.level === "Advanced" ? "85%" : "70%",
                        backgroundColor: getLevelColor(skill.level)
                      }}
                    ></div>
                  </div>
                </div>
              ))}
            </div>
          </div>

          <div className="skill-category-card">
            <div className="skill-category-header">
              <h3 className="skill-category-title">Tools & Technologies</h3>
              <p className="skill-category-desc">Essential tools for development and deployment</p>
            </div>
            <div className="skill-items">
              {skills.tools.map((skill, index) => (
                <div key={index} className="skill-item">
                  <div className="skill-item-header">
                    <span className="skill-name">{skill.name}</span>
                    <span 
                      className="skill-level" 
                      style={{ color: getLevelColor(skill.level) }}
                    >
                      {skill.level}
                    </span>
                  </div>
                  <div className="skill-progress-bar">
                    <div 
                      className="skill-progress-fill"
                      style={{ 
                        width: skill.level === "Expert" ? "100%" : skill.level === "Advanced" ? "85%" : "70%",
                        backgroundColor: getLevelColor(skill.level)
                      }}
                    ></div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
);

export default SkillsPage;

